'use strict';
var React = require('react');
var ReactDOM = require('react-dom');
var connect = require('react-redux').connect;
var Actions = require('../actions/AppActions');
var domHelper = require('../helper/domHelper');
var pageHelper = require('../helper/pageHelper');
var PreviewMixin = require('./Mixin/Preview.jsx');
var _ = require('underscore');

var MainStage = require('./MainStage');
var MobilePreviewPanel = require('./MobilePreviewPanel');
var ControlBall = require('./ControlBall');
var assetsHelper = require('../helper/assetsHelper');
var cacheHelper = require('../helper/cacheHelper');

var MobilePreview = React.createClass({
  propTypes: {
    current: React.PropTypes.object,
    target: React.PropTypes.object,
    animation: React.PropTypes.object,
    path: React.PropTypes.string.isRequired,
    onOpenPage: React.PropTypes.func.isRequired,
    onFinishOpenPage: React.PropTypes.func.isRequired
  },
  mixins: [PreviewMixin],
  getInitialState: function () {
    var config = this.props.config;
    var platform = this.props.app.params.projectParam.platform;
    return _.extend(config, {
      domSize: domHelper.getDocumentSize(),
      showPanel: false,
      canFix: platform === 'MtMobile' || platform === 'MtPad'
    });
  },
  componentDidMount: function () {
    this.props.onLoadApp(this.props.app);
    domHelper.onDocumentResize(this.onDomSizeChange);
  },
  componentWillUnmount: function () {
    domHelper.offDocumentResize(this.onDomSizeChange);
  },
  onDomSizeChange: function () {
    this.setState({
      domSize: domHelper.getDocumentSize()
    });
  },
  render: function () {
    var currentPage;
    var pageMetaInfo;
    var scale;
    var previewStyle;
    var toHeight;
    var previewPanelBackgroundStyle = {};
    if (!this.props.current) {
      return (
        <div className="preview-loading">
          <img width="120" height="120" src={this.state.logo} alt="Mockplus"/>
        </div>
      );
    }

    currentPage = this.props.current;
    pageMetaInfo = pageHelper.getMobileDeviceMetaInfo(currentPage, this.props.meta);

    scale = this.state.domSize.width / pageMetaInfo.pageSize.x;
    // scale = 1;
    toHeight = this.state.domSize.height / scale;
    previewStyle = {
      transform: 'scale(' + scale + ')',
      left: 0,
      top: 10
    };

    if (!this.state.showPanel) {
      previewPanelBackgroundStyle.display = 'none';
    }
    return (
      <div className="mobile-preview" onClick={this._onPreviewClick}>
        <div style={previewPanelBackgroundStyle} className="mobile-preview-panel-background"
             onClick={this.onTogglePanel}></div>
        <MobilePreviewPanel
          app={this.props.app}
          current={this.props.current}
          showPanel={this.state.showPanel}
          onOpenPage={this.onOpenPageFromPanel}
        />
        <ControlBall onTogglePanel={this.onTogglePanel} domSize={this.state.domSize}/>
        <div className="scale-container" style={previewStyle}>
          <MainStage
            current={this.props.current}
            target={this.props.target}
            onOpenPage={this.onOpenPage}
            onFinishOpenPage={this.onFinishOpenPage}
            onRedirectTo={this.onRedirectTo}
            animation={this.props.animation}
            canFix={this.state.canFix}
            size={{
              width: pageMetaInfo.pageSize.x,
              height: toHeight
            }}
            domSize={{
              width: pageMetaInfo.pageSize.x,
              height: toHeight
            }}
            showComments={false}
            onShowRemark={this.fakeMethod}
            orientation={this.props.meta.orientation}
            pageNeedRerender={true}
          />
        </div>
      </div>
    );
  },
  /**
   * 点击空白处，闪烁提示链接
   * @private
   */
  _onPreviewClick: function (e) {
    if (this.props.config.hintLinks) {
      var $this = $(ReactDOM.findDOMNode(this));
      $this.addClass('click-show-links');
      setTimeout(function () {
        $this.removeClass('click-show-links');
      }, 800);
    }
  },
  onTogglePanel: function () {
    this.setState({
      showPanel: !this.state.showPanel
    });
  },
  onOpenPageFromPanel: function (pageID) {
    var self = this;
    this.setState({
      showPanel: false
    }, function () {
      setTimeout(function () {
        self.props.onOpenPage(pageID);
      }, 200);
    });
  },
  fakeMethod: function () {
  },
  onFinishOpenPage: function () {
    this.props.onFinishOpenPage(this.props.target);
  }
});

function mapStateToProps(state) {
  cacheHelper.cache(cacheHelper.keys.PROJECT_VERSION, state.app && state.app.params.projectParam.version);
  cacheHelper.cache(cacheHelper.keys.PAGE_VERSION, state.current && state.current.version);
  cacheHelper.cache(cacheHelper.keys.PLATFORM, state.app && state.app.params.projectParam.platform);
  return {
    app: state.app,
    meta: state.app && state.app.params.projectParam,
    current: state.current,
    target: state.target,
    animation: state.animation,
    config: state.config
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onLoadApp: function (path) {
      dispatch(Actions.loadApp(path));
    },
    onOpenPage: function (id) {
      dispatch(Actions.openPage(id));
    },
    onFinishOpenPage: function (targetPage) {
      dispatch(Actions.finishOpenPage(targetPage));
    },
    onRedirectTo: function (id, animation) {
      dispatch(Actions.redirectPage(id, animation));
    }
  };
}

module.exports = connect(mapStateToProps, mapDispatchToProps)(MobilePreview);



// WEBPACK FOOTER //
// ./src/views/MobilePreview.jsx